(function () {
  angular.module("akitabox.building.detail", [
    "ui.router",
    "akitabox.constants",
    "akitabox.ui.components.dashboard",
  ]);
})();
